import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RecruiterDataService, Assessment } from '../../services/recruiter-data.service';

interface AssessmentCandidate {
  name: string;
  email: string;
  score: number;
  status: 'Shortlisted' | 'Applied' | 'Selected' | 'Rejected';
}

@Component({
  selector: 'app-tab-assessments',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './tab-assessments.component.html',
  styleUrls: ['./tab-assessments.component.scss']
})
export class TabAssessmentsComponent implements OnInit {
  allAssessments: Assessment[] = [];

  assessmentSearchQuery = '';

  // Create Popup Modal State
  isCreatePopupOpen = false;
  newTitle = '';
  newDuration = '60 min';
  newQuestionsCount = 10;

  // View Candidates Popup State
  isCandidatesPopupOpen = false;
  selectedAssessment: Assessment | null = null;
  assessmentCandidates: AssessmentCandidate[] = [];

  // Seeding high-fidelity candidates corresponding to each assessment ID
  mockCandidatesByAssessment: { [key: number]: AssessmentCandidate[] } = {
    1: [
      { name: 'Rahul Sharma', email: 'rahul@iitb.ac.in', score: 85, status: 'Shortlisted' },
      { name: 'Priya Patel', email: 'priya@nits.ac.in', score: 72, status: 'Applied' },
      { name: 'Amit Kumar', email: 'amit@bits.ac.in', score: 90, status: 'Selected' }
    ],
    2: [
      { name: 'Neha Gupta', email: 'neha@example.com', score: 82, status: 'Selected' },
      { name: 'Rahul Kumar', email: 'rahul@bits.ac.in', score: 65, status: 'Applied' },
      { name: 'Kavitha Reddy', email: 'kavitha@example.com', score: 76, status: 'Shortlisted' }
    ],
    3: [] // Empty state / no candidates for wqeqwe assessment
  };

  constructor(private dataService: RecruiterDataService) {}

  ngOnInit(): void {
    this.allAssessments = this.dataService.allAssessments;
  }

  get filteredAssessments(): Assessment[] {
    return this.allAssessments.filter(assessment => {
      const titleMatch = assessment.title?.toLowerCase().includes(this.assessmentSearchQuery.toLowerCase());
      const subTitleMatch = assessment.subTitle?.toLowerCase().includes(this.assessmentSearchQuery.toLowerCase());
      return titleMatch || subTitleMatch;
    });
  }

  // Create popup controls
  openCreatePopup(): void {
    this.isCreatePopupOpen = true;
    this.newTitle = '';
    this.newDuration = '60 min';
    this.newQuestionsCount = 10;
  }

  closeCreatePopup(): void {
    this.isCreatePopupOpen = false;
  }

  createAssessment(): void {
    if (!this.newTitle.trim()) {
      alert('Please enter an assessment title.');
      return;
    }

    const durationValue = parseInt(this.newDuration) || 60;
    const nextId = Math.max(...this.allAssessments.map(a => a.id), 0) + 1;
    const newAssessment: Assessment = {
      id: nextId,
      title: this.newTitle.trim(),
      subTitle: 'Evaluate candidates on general knowledge and technical expertise',
      duration: durationValue,
      questionsCount: this.newQuestionsCount || 10,
      candidatesCount: 0,
      status: 'Active'
    };

    // Prepend to show immediately
    this.dataService.allAssessments.unshift(newAssessment);
    this.allAssessments = this.dataService.allAssessments;

    this.closeCreatePopup();
  }

  // View Candidates Popup controls
  openCandidatesPopup(assessment: Assessment): void {
    this.selectedAssessment = assessment;
    this.assessmentCandidates = this.mockCandidatesByAssessment[assessment.id] || [
      { name: 'Arjun Mehta', email: 'arjun@example.com', score: 88, status: 'Shortlisted' },
      { name: 'Sneha Rao', email: 'sneha@example.com', score: 74, status: 'Applied' }
    ];
    this.isCandidatesPopupOpen = true;
  }

  closeCandidatesPopup(): void {
    this.isCandidatesPopupOpen = false;
    this.selectedAssessment = null;
    this.assessmentCandidates = [];
  }
}
